<template>
 <div class="agreement-modal">
   <el-dialog :title="title" :visible="showModal" width="600px" top="3vh" :close-on-click-modal="false"
              :modal="true" :append-to-body="true" @close="closeModal">

     <el-form>
       <el-form-item label="Title">
         <el-input v-model="agreement.title"></el-input>
       </el-form-item>
       <el-form-item label="User Type" class="mt20">
         <el-select v-model="agreement.user_type" filterable>
           <el-option value="mcn_manager" label="Label/Artist"> </el-option>
           <el-option value="channel" label="Channel"></el-option>
         </el-select>
       </el-form-item>
       <el-form-item label="Page Type" class="mt20">
         <el-select v-model="agreement.page_type" filterable>
           <el-option v-for="(key, value) in types" :key="key" :value="key" :label="transformPageLabel(value)">
           </el-option>
         </el-select>
       </el-form-item>
       <el-form-item v-if="modalAction === 'update'" label="Version Number">
         <el-input v-model="agreement.version_number"></el-input>
       </el-form-item>
       <el-form-item prop="content" class="mt30">
         <vue-editor v-model="agreement.content" />
       </el-form-item>
     </el-form>
     <div slot="footer">
       <el-button type="primary" size="mini" :loading="loading" @click="createOrUpdate"> Save </el-button>
     </div>
   </el-dialog>
 </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { mapActions, mapMutations, mapState } from "vuex"

export default {
  name: "Modal",

  components: { VueEditor },

  computed: {
    ...mapState('agreement', ['modalAction', 'showModal', 'loading', 'agreement', 'types']),

    title() {
      if (this.modalAction === 'create') return 'Create new agreement'
      else if (this.modalAction === 'update') return 'Edit agreement'
      return ''
    },
  },

  methods: {
    ...mapMutations('agreement', ['setModal', 'setAgreement']),
    ...mapActions('agreement', ['createOrUpdate']),

    closeModal() {
      this.setModal(false)
      this.setAgreement({})
    },

    transformPageLabel(label) {
      label = label.replaceAll('_', ' ')

      return label.split(' ')
          .map(_ => _.charAt(0).toUpperCase() + _.slice(1))
          .join(' ')
    }
  }
}
</script>

<style scoped lang="scss">

</style>